function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  viewBox: "0 0 71 71",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M71 35.5H-1.13249e-06",
  stroke: "#370E7B",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.5 71L35.5 -1.13249e-06",
  stroke: "#370E7B",
  strokeWidth: "2"
}));